import { useEffect } from "react"
import { Grid } from '@material-ui/core'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import { useSelector, useDispatch } from "react-redux"
import { addIndividualAction, addItemsAction, obtenerPlazaPersona } from '../../../../../ducks/cotizadorPaqueteDuck'
import { ToastMessage } from "../../../../../global/ToastMessage"
const FieldIndividual = () => {
    const { listaPlazaPerona, clavePaquete, individual, cantidadPasajeros, paquete, listaItems, listaHabitaciones } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerPlazaPersona({ ClavePaquete: clavePaquete, NumeroPersonas: cantidadPasajeros }))
    }, [dispatch, clavePaquete, cantidadPasajeros])

    const handleChange = (event) => {
        const newValue = event.target.value
        const newArrarValue = newValue.split(',')
        let arrayItems = [...listaItems]
        arrayItems = listaItems.filter(item => item.type !== "PLAZA")
        const habitaciones = newArrarValue.map((val, index) => {
            const [id, cantidad] = val.split('-')
            const supHabitacion = listaHabitaciones.find(plaza => plaza.IdTipoPlaza === Number(id))
            if (supHabitacion) {
                let itemHabitacion = {}
                return itemHabitacion = {
                    id: supHabitacion.IdObjeto,
                    name: `${supHabitacion.Descripcion}`,
                    price: supHabitacion.Suplemento,
                    currency: paquete.Moneda?.Clave,
                    type: "PLAZA",
                    quantity: cantidad
                }
            }
        })
        arrayItems = arrayItems.concat(habitaciones)
        dispatch(addIndividualAction({ individual: `${newValue}` }))
        dispatch(addItemsAction({ listaItem: arrayItems }))
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <FormControl component="fieldset">
                    <RadioGroup aria-label="gender" name="gender1" value={individual} onChange={handleChange}>
                        <FormControlLabel disabled value="0" control={<Radio />} label="No aplica" />
                        {
                            listaPlazaPerona.map((grupo, index) => {
                                if (grupo.lHabitacionAcomodo) {
                                    const id = grupo?.lHabitacionAcomodo.flatMap(
                                        (v, i) => `${v.IdTipoHabiacion}-${v.Cantidad}`
                                    )
                                    return (
                                        <FormControlLabel
                                            key={id}
                                            value={`${id}`}
                                            control={<Radio />}
                                            label={`${grupo?.lHabitacionAcomodo.flatMap(
                                                (v, i) => `${v.Cantidad} Hab. ${v.Descripcion}`
                                            ).join(" y ")}`}
                                        />
                                    )
                                }
                            })
                        }
                    </RadioGroup>
                </FormControl>
            </Grid>
        </Grid>
    )
}
export default FieldIndividual